import store from '@custom/shared/store/store.js';

const isSafeInternalRedirect = redirect => (
    typeof redirect === 'string' &&
    redirect.startsWith('/') &&
    !redirect.startsWith('//') &&
    !redirect.startsWith('/\\')
);

// router.js 는 meta.requireAuth 를 쓴다(requiresAuth 는 한 곳뿐) — 둘 다 본다
const isAuthRequired = to => to.matched.some(record => record.meta.requiresAuth || record.meta.requireAuth);

// 리다이렉트는 replace 로 — push 면 처음 연 주소가 히스토리에 한 칸 더 남아 뒤로가기가 같은 화면에 머문다
const requiresNotAuthGuard = async (to, from, next) => {
    const requiresAuth = isAuthRequired(to);
    const _company_type = localStorage.getItem('type');
    const currentUser = localStorage.getItem('accessToken');

    if (!_company_type || !currentUser || to.name.includes('Register')) {
        next();
    } else {
        if (!requiresAuth && currentUser) {
            if (isSafeInternalRedirect(to.query.redirect)) {
                next({path: to.query.redirect, replace: true});
                return;
            }
            if (_company_type === 'request') {
                const _company_id = localStorage.getItem('company_id');
                next({
                    name: 'ContractorProgress',
                    params: { requestsId: _company_id },
                    replace: true
                });
            } else {
                next({ name: 'Main', replace: true });
            }
        } else {
            next();
        }
    }
};

const requiresAuthGurard = async (to, from, next) => {
    const requiresAuth = isAuthRequired(to);
    const _company_type = localStorage.getItem('type');
    const currentUser = localStorage.getItem('accessToken');

    if (requiresAuth && (!currentUser || !_company_type)) {
        next({ name: 'Login', query: { redirect: to.fullPath }, replace: true });
    } else {
        const company_id = localStorage.getItem('company_id');
        if (!company_id) {
            await store.dispatch('logout');
            localStorage.clear();
            next({ name: 'Login', query: { redirect: to.fullPath }, replace: true });
        } else if (to.name.includes('Register')) {
            next();
        } else if (_company_type === 'request' && to.meta.dashboardType !== 'contractor' && to.name !== 'McpAuthorize') {
            // MCP 연결 승인은 로그인 유형이 아니라 관리자 등급으로 서버가 판단한다 — 의뢰기업 계정도 승인 화면까지 보낸다
            next({
                name: 'ContractorProgress',
                params: { 'requestsId': company_id },
                replace: true
            });
        } else if (_company_type !== 'request' && to.meta.dashboardType === 'contractor') {
            next({ name: 'Main', replace: true });
        } else {
            next();
        }
    }
};

export {
    requiresAuthGurard,
    requiresNotAuthGuard,
};
